/**
 * Inactivity Tracker Utility
 * Automatically logs out user after 10 minutes of inactivity
 */

const INACTIVITY_TIMEOUT = 10 * 60 * 1000; // 10 minutes in milliseconds

class InactivityTracker {
    constructor() {
        this.timeoutId = null;
        this.events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
        this.isEnabled = false;
    }

    /**
     * Reset the inactivity timer
     */
    resetTimer = () => {
        // Clear existing timer
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }

        // Set new timer
        this.timeoutId = setTimeout(() => {
            this.handleInactivityTimeout();
        }, INACTIVITY_TIMEOUT);
    };

    /**
     * Handle inactivity timeout - logout user
     */
    handleInactivityTimeout = () => {
        console.log('User inactive for 30 minutes. Logging out...');
        
        // Clear session storage
        window.sessionStorage.removeItem("user_id");
        window.sessionStorage.removeItem("user_jwt");
        window.sessionStorage.removeItem("jwt_refresh_token");
        window.sessionStorage.removeItem("register_user_id");
        window.sessionStorage.removeItem("register_user_email");
        window.sessionStorage.removeItem("temp_login_id");
        window.sessionStorage.removeItem("temp_user_email");

        // Check if demo user and redirect accordingly
        if (window.sessionStorage.getItem("demouser") === "Yes") {
            window.sessionStorage.removeItem("demouser");
            window.location.href = process.env.REACT_APP_SITE_URL + "demologin";
        } else {
            window.sessionStorage.removeItem("demouser");
            window.location.href = process.env.REACT_APP_SITE_URL + "login";
        }
    };

    /**
     * Start tracking user activity
     */
    startTracking = () => {
        if (this.isEnabled) {
            return; // Already tracking
        }

        this.isEnabled = true;
        
        // Set initial timer
        this.resetTimer();

        // Add event listeners for user activity
        this.events.forEach(event => {
            window.addEventListener(event, this.resetTimer, true);
        });
    };

    /**
     * Stop tracking user activity
     */
    stopTracking = () => {
        if (!this.isEnabled) {
            return; // Not tracking
        }

        this.isEnabled = false;

        // Clear timer
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }

        // Remove event listeners
        this.events.forEach(event => {
            window.removeEventListener(event, this.resetTimer, true);
        });
    };

    /**
     * Check if user is authenticated
     */
    isUserAuthenticated = () => {
        return !!window.sessionStorage.getItem("user_jwt");
    };
}

// Create singleton instance
const inactivityTracker = new InactivityTracker();

export default inactivityTracker;
